import React from "react";
import { Modal, ModalBody } from "reactstrap";

const DetailRow = ({ label, value }) => (
  <div className="fr-detail-row">
    <span className="fr-detail-row__label">{label}</span>
    <span className="fr-detail-row__value">{value || "-"}</span>
  </div>
);

const FeatureRequestDetailModal = ({
  isOpen,
  record,
  isLibrary,
  onClose,
  onMarkDone,
  onReopen,
  onRequestDelete,
  isMarkingDone,
  isReopening,
  isDeleting,
}) => {
  if (!record) {
    return null;
  }

  const userName = record.user
    ? `${record.user.first_name || ""} ${record.user.last_name || ""}`.trim()
    : "Unknown user";

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size="lg"
      className="fr-detail-modal-dialog"
      contentClassName="fr-detail-modal-content"
    >
      <ModalBody className="fr-detail-modal-body fr-detail-modal-body--flush">
        <div
          className="fr-detail-modal-hero"
          style={{
            background: "linear-gradient(135deg, #255a77 0%, #1f4d66 100%)",
          }}
        >
          <button
            type="button"
            className="fr-detail-modal-hero__close"
            aria-label="Close"
            onClick={onClose}
          >
            ×
          </button>
          <h2
            className="fr-detail-modal-hero__title"
            style={{ color: "#ffffff", margin: "0 0 8px" }}
          >
            {record.title}
          </h2>
          <p
            className="fr-detail-modal-hero__subtitle"
            style={{ color: "rgba(255, 255, 255, 0.88)", margin: 0 }}
          >
            Submitted {record.created_at}
            {isLibrary && record.marked_done_at
              ? ` · Completed ${record.marked_done_at}`
              : ""}
          </p>
        </div>

        <div className="fr-detail-modal-body__inner">
          <div className="fr-detail-badges">
            <span className="fr-badge fr-badge--priority">{record.priority}</span>
            <span className="fr-badge fr-badge--category">
              {record.category_label}
            </span>
            {isLibrary ? (
              <span className="fr-badge fr-badge--done">Done</span>
            ) : null}
            <span
              className={`fr-badge ${
                record.is_paid ? "fr-badge--paid" : "fr-badge--unpaid"
              }`}
            >
              {record.paid_label}
            </span>
            <span className="fr-badge fr-badge--plan">{record.plan_name}</span>
            <span
              className={`fr-badge ${
                record.is_active ? "fr-badge--active" : "fr-badge--inactive"
              }`}
            >
              {record.is_active ? "Active user" : "Inactive user"}
            </span>
          </div>

          <section className="fr-detail-section">
            <h6 className="fr-detail-section__title">Request</h6>
            <div className="fr-detail-description">{record.description}</div>
          </section>

          <div className="fr-detail-columns">
            <section className="fr-detail-section">
              <h6 className="fr-detail-section__title">User</h6>
              <DetailRow label="Name" value={userName} />
              <DetailRow label="Email" value={record.user?.email} />
              <DetailRow
                label="Last login"
                value={record.user?.last_login_at || "Never"}
              />
              <DetailRow
                label="Account created"
                value={record.user?.account_created_at}
              />
            </section>

            <section className="fr-detail-section">
              <h6 className="fr-detail-section__title">Company</h6>
              <DetailRow
                label="Name"
                value={
                  record.company?.company_name || record.company?.business_name
                }
              />
              <DetailRow label="Email" value={record.company?.company_email} />
              <DetailRow label="Slug" value={record.company?.slug} />
              <DetailRow
                label="Employees"
                value={
                  record.company?.num_of_emp != null
                    ? String(record.company.num_of_emp)
                    : "-"
                }
              />
            </section>
          </div>

          <section className="fr-detail-section fr-detail-section--last">
            <h6 className="fr-detail-section__title">Product activity</h6>
            <div className="fr-detail-metrics">
              <div className="fr-detail-metric">
                <span className="fr-detail-metric__label">Events</span>
                <strong className="fr-detail-metric__value">
                  {record.activity?.events_count ?? 0}
                </strong>
              </div>
              <div className="fr-detail-metric">
                <span className="fr-detail-metric__label">
                  Recent bookings (90d)
                </span>
                <strong className="fr-detail-metric__value">
                  {record.activity?.recent_bookings_count ?? 0}
                </strong>
              </div>
              <div className="fr-detail-metric">
                <span className="fr-detail-metric__label">Total bookings</span>
                <strong className="fr-detail-metric__value">
                  {record.activity?.bookings_count ?? 0}
                </strong>
              </div>
            </div>
            {record.activity?.summary ? (
              <p className="fr-detail-summary">{record.activity.summary}</p>
            ) : null}
          </section>

          <div className="fr-detail-actions">
            {isLibrary ? (
              <button
                type="button"
                className="btn btn-outline fr-detail-reopen-btn"
                disabled={isReopening || isDeleting}
                onClick={() => onReopen(record)}
              >
                {isReopening ? "Saving..." : "Move back to inbox"}
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-app fr-detail-done-btn"
                disabled={isMarkingDone || isDeleting}
                onClick={() => onMarkDone(record)}
              >
                {isMarkingDone ? "Saving..." : "Mark as done"}
              </button>
            )}
            <button
              type="button"
              className="btn btn-outline fr-detail-delete-btn"
              disabled={isMarkingDone || isReopening || isDeleting}
              onClick={() => onRequestDelete(record)}
            >
              Delete
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FeatureRequestDetailModal;
